const sizes = {
  navigationHeight: `61px`,
}

export default sizes
